/**
 * Parallax types
 * one - product card
 * two - text to the side
 * three - text overlay
 */
class ParallaxSection extends HTMLElement {
    
    connectedCallback () {
        this.activated = this.activated ?? false;
        this.type = ['parallax_one', 'parallax_two', 'parallax_three'].includes(this.dataset.type) ? this.dataset.type : 'parallax_one';

        if (!this.activated) {
            switch (this.type) {
                case "parallax_one":
                    this.activateParallaxOne();
                    break;
                case "parallax_two":
                    this.activateParallaxTwo();
                    break;
                case "parallax_three":
                    this.activateParallaxThree();
                    break;
            }
        }
    }

    wrapChildren (parent, children, wrapperClass) {
        if (!parent || !children?.length) return null;
    
        const wrapper = document.createElement('div');
        if (wrapperClass) wrapper.className = wrapperClass;
        parent.insertBefore(wrapper, children[0]);
        [...children].forEach(child => wrapper.appendChild(child));
    
        return wrapper;
    }

    outerHeight (el, includeMargin = false) {
        if (!el) return 0;
      
        const rect = el.getBoundingClientRect();
        let height = rect.height; // includes content + padding + border, as a float
      
        if (includeMargin) {
          const style = getComputedStyle(el);
          const marginTop = parseFloat(style.marginTop) || 0;
          const marginBottom = parseFloat(style.marginBottom) || 0;
          height += marginTop + marginBottom;
        }
      
        return height;
      }

    activateParallaxOne () {
        // find the next product card and appropriate
        let contentContainer = this.closest('[class*="content_"]');
        contentContainer.classList.add('parallax-content--one');

        const order = parseInt(getComputedStyle(contentContainer).order);
        
        // read the aspect ratio
        const targetImage = this.querySelector('picture');
        if (!targetImage) { // is a video 
            this.style.setProperty('--image-height', `50vw`);
            this.querySelector('.hero__content-container')?.remove();
        } else {
            const naturalWidth = targetImage.dataset.sourceWidth;
            const naturalHeight = targetImage.dataset.sourceHeight;
            const ratio = naturalHeight / naturalWidth;
            this.style.setProperty('--image-height', `${50 * ratio}vw`);
        }

        // if (window.innerWidth < 1024) {
        //     let sentinel = this.querySelector('.sentinel');
        //     if (!sentinel) {
        //         sentinel = document.createElement('div');
        //         sentinel.className = 'sticky-sentinel';
        //         targetProductCard.parentNode.insertBefore(sentinel, targetProductCard);
        //     }

        //     const placeholder = document.createElement('div');
        //     let isFixed = false;

        //     placeholder.style.height = `${this.outerHeight(targetProductCard, true)}px`;

        //     const observer = new IntersectionObserver(
        //         ([entry]) => {
        //           if (entry.boundingClientRect.top < 0 && !isFixed) {
        //             targetProductCard.classList.add('is-fixed');
        //             targetProductCard.parentNode.insertBefore(placeholder, targetProductCard);
        //             document.body.appendChild(targetProductCard);
        //             isFixed = true;
        //           } 
        //           else if (entry.boundingClientRect.top >= 0 && isFixed) {
        //             targetProductCard.classList.remove('is-fixed');
        //             placeholder.parentNode.insertBefore(targetProductCard, placeholder);
        //             placeholder.remove();
        //             isFixed = false;
        //           }
        //         },
        //         { threshold: [0] }
        //       );
              
        //       observer.observe(sentinel);
        // }
    }

    activateParallaxTwo () {
        let contentContainer = this.closest('[class*="content_"]');
        contentContainer.classList.add('parallax-content--two');

        const textLink = this.querySelector('.hero__footer a.text-link');
        if (textLink) {
            this.querySelector('.hero__body .hero__paragraph').appendChild(textLink);
            textLink.setAttribute('href', this.querySelector('.hero__footer .hyperlink-element')?.getAttribute('href'));
        }

        // read the aspect ratio
        const targetImage = this.querySelector('picture');
        const naturalWidth = targetImage.dataset.sourceWidth;
        const naturalHeight = targetImage.dataset.sourceHeight;
        const ratio = naturalHeight / naturalWidth;
        this.style.setProperty('--image-height', `${50 * ratio}vw`);
    }

    activateParallaxThree () {
        let contentContainer = this.closest('[class*="content_"]');
        contentContainer.classList.add('parallax-content--three');

        // read the aspect ratio
        const targetImage = this.querySelector('picture');
        const naturalWidth = targetImage.dataset.sourceWidth;
        const naturalHeight = targetImage.dataset.sourceHeight;
        const ratio = naturalHeight / naturalWidth;
        this.style.setProperty('--image-height', `calc(${71 * ratio}vw - 64px)`);

        const parent = this.querySelector('.hero__content-container');
        this.wrapChildren(parent, this.querySelectorAll('.hero__content-container > *'), 'hero__sticky-wrapper');
    }
}

customElements.define('parallax-section', ParallaxSection);